import { apiClient, retryRequest } from './httpClient';
import logger from '../utils/logger';

export async function apiRequest(endpoint, method = "GET", data = null, options = {}) {
    const requestConfig = {
        url: endpoint,
        method: method.toUpperCase(),
        ...options
    };

    if (data) {
        if (method.toUpperCase() === 'GET') {
            requestConfig.params = data;
        } else {
            requestConfig.data = data;
        }
    }

    try {
        const response = await retryRequest(() => apiClient(requestConfig));
        return response.data;
    } catch (error) {
        logger.error(`ToDo API Request failed for ${method} ${endpoint}:`, error);
        const apiError = new Error(error.data || 'API request failed');
        apiError.status = error.status || 500;
        apiError.endpoint = endpoint;
        apiError.method = method;
        throw apiError;
    }
}